module.exports = " <div class=avatar-wrapper _v-3dc53a44=\"\"> <div class=avatar-inner _v-3dc53a44=\"\"> <a class=avatar-model data-open=avatarModel @click=openAvatar :style=avatarImg _v-3dc53a44=\"\"> <div class=caption _v-3dc53a44=\"\"><span _v-3dc53a44=\"\">{{ detail.name }}</span></div> </a> <a class=avatar-mask _v-3dc53a44=\"\"></a> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-3dc53a44!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Avatar.vue
 ** module id = 59
 ** module chunks = 1
 **/